import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import { useNavigate } from "react-router-dom";
import Building from "../../Services/buildingService";

function BuildingList(props) {
  const columns = [
    {
      dataField: "name",
      text: "Building Name",
    },
    {
      dataField: "code",
      text: "Code",
      width: "5%",
    },
    {
      dataField: "rent_unit_price",
      text: "Rent",
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "phone",
      text: "Phone",
    },
    {
      dataField: "location",
      text: "Location",
    },
    {
      dataField: "actions",
      text: "Action",
      formatter: (cellContent, row) => {
        return (
          <div>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => navigate(`/building-details/${row._id}`)}
            >
              <img src="/assets/img/icons/eye.svg" alt="img" />
            </button>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => editBuilding(row._id)}
            >
              <img src="assets/img/icons/edit.svg"></img>
            </button>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => deleteBuilding(row._id)}
            >
              <img src="assets/img/icons/delete.svg"></img>
            </button>
          </div>
        );
      },
    },
  ];

  const navigate = useNavigate();
  const [buildingList, setbuildingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 5,
    },
  });
  const handleTableChange = (pagination, filter, sorter) => {
    setIsFilter(false);
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setbuildingList([]);
    }
  };
  const getBuildingList = async () => {
    setLoading(true);
    await Building.getAll()
      .then((data) => {
        setbuildingList(data.data.data.buildings);
        console.log("buildingList", data.data.data.buildings);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const editBuilding = (id) => {
    navigate(`/edit-building/${id}`);
  };

  const deleteBuilding = async (id) => {
    setLoading(true);
    await Building.remove({ id: id })
      .then(() => {
        getBuildingList();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getBuildingList();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>Buildings List</h4>
              <h6>Manage your buildings</h6>
            </div>
            <div class="page-btn">
              <a href="/add-building" class="btn btn-added">
                <img src="/assets/img/icons/plus.svg" alt="img" class="me-1" />
                Add New Building
              </a>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="table-top">
                <div class="search-set">
                  <div class="search-path">
                    <a class="btn btn-filter" id="filter_search">
                      <img src="/assets/img/icons/filter.svg" alt="img" />
                      <span>
                        <img src="/assets/img/icons/closes.svg" alt="img" />
                      </span>
                    </a>
                  </div>
                  <div class="search-input">
                    <a class="btn btn-searchset">
                      <img src="/assets/img/icons/search-white.svg" alt="img" />
                    </a>
                  </div>
                </div>
                <div class="wordset">
                  <ul>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="pdf"
                      >
                        <img src="/assets/img/icons/pdf.svg" alt="img" />
                      </a>
                    </li>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="excel"
                      >
                        <img src="/assets/img/icons/excel.svg" alt="img" />
                      </a>
                    </li>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="print"
                      >
                        <img src="/assets/img/icons/printer.svg" alt="img" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-0" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12">
                      <div class="row">
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Shop</option>
                              <option>Macbook pro</option>
                              <option>Orange</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Category</option>
                              <option>Computers</option>
                              <option>Fruits</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Sub Category</option>
                              <option>Computer</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Brand</option>
                              <option>N/D</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12 ">
                          <div class="form-group">
                            <select class="select">
                              <option>Price</option>
                              <option>150.00</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-1 col-sm-6 col-12">
                          <div class="form-group">
                            <a class="btn btn-filters ms-auto">
                              <img
                                src="/assets/img/icons/search-whites.svg"
                                alt="img"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <BootstrapTable
                bootstrap4
                bordered={false}
                keyField="_id"
                data={buildingList}
                columns={columns}
                selectRow={{ mode: "checkbox" }}
              />
              {/* <TB
                                class="table-responsive table"
                                style={{ fontSize: 25, fontFamily: "arial" }}
                                size="large"
                                columns={columns}
                                pagination={tableParams.pagination}
                                onChange={handleTableChange}
                                loading={loading}
                                dataSource={buildingList?.map((item, index) => ({
                                    key: item._id,

                                    name: <p>{item.name}</p>,

                                    shop_number: item.shop_number,
                                    floor: item.floor.floor_number,
                                    area: `${item.area}sqf`,
                                    rental_rate: `$${item.rental_rate}`,
                                    occupied: item.occupied ? "Yes" : "No",
                                    shopkeeper: item.shopkeeper[0].name,
                                    rental_history: item.rental_history[0].amount,
                                    //   shops: item.shops.map((shop) => `${shop.shop_number}-`),
                                    action: (
                                        <div>
                                            <button
                                                style={{
                                                    backgroundColor: "transparent",
                                                    border: "0px",
                                                }}
                                                onClick={() =>
                                                    navigate(`/shopkeeper-details/${item._id}`)
                                                }
                                            >
                                                <img src="/assets/img/icons/eye.svg" alt="img" />
                                            </button>
                                            <button
                                                style={{
                                                    backgroundColor: "transparent",
                                                    border: "0px",
                                                }}
                                                onClick={() => editShop(item._id)}
                                            >
                                                <img src="assets/img/icons/edit.svg"></img>
                                            </button>
                                            <button
                                                style={{
                                                    backgroundColor: "transparent",
                                                    border: "0px",
                                                }}
                                                onClick={() => deleteShop(item._id)}
                                            >
                                                <img src="assets/img/icons/delete.svg"></img>
                                            </button>
                                        </div>
                                    ),
                                }))}
                            /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BuildingList;
